<template>
	<div id="app">
		<v-app id="inspire">
            <v-card height="100%">
                <v-parallax dark class="blue-grey darken-4" height="70">
                    <v-container>
                        <v-layout>
                            <h4 class="subheading font-weight-medium">Customer Profile</h4>
                        </v-layout>
                    </v-container>
                </v-parallax> 
            
                <v-card-text>
                    <v-container grid-list-md class="pt-0">
                        <v-layout wrap>
                            <v-flex xs6 v-if="!Auth.user.mobileNumber">
                                <v-flex xs12>
                                    <v-text-field v-model="firstName" hide-details label="First Name*"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field v-model="middleName" hide-details label="Middle Name"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field v-model="lastName" hide-details label="Last Name*"></v-text-field>
                                </v-flex>

                                <v-layout>
                                    <v-flex xs3>
                                        <v-text-field label="Country Code" hide-details readonly type="text" required value="+63" ></v-text-field>
                                    </v-flex>
                                    <v-flex xs9>
                                        <v-text-field v-model="mobileNumber" hide-details :rules="mobileChecker" label="Mobile Number*" maxlength="10" type="text" required hint=" ex.9123456789"></v-text-field>
                                    </v-flex>
                                </v-layout>

                                <v-flex xs12>
                                    <v-text-field v-model="address.brgy" hide-details label="Barangay*"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field v-model="address.city" hide-details label="City*"></v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                    <v-text-field v-model="address.state" hide-details label="Province*"></v-text-field>
                                </v-flex>

                                <!-- <v-flex xs12>
                                    <v-text-field v-model="tin" hide-details label="TIN"></v-text-field>
                                </v-flex> -->

                                <!-- <v-layout justify-center>
                                    <v-card-actions>
                                        <v-btn dark color="blue darken-4" @click="saveUserDetails()">Save</v-btn>
                                    </v-card-actions>
                                </v-layout> -->
                            </v-flex>
                            <!-- :xs6="!showMotorcycleOnly" :xs12="showMotorcycleOnly" -->
                            <v-flex :xs6="!showMotorcycleOnly" :xs12="showMotorcycleOnly">
                                <v-flex xs12 sm12 md12>
                                    <v-select v-model="dealer" label="Dealer/Store*" required
                                        :items="dealers" hide-details
                                    ></v-select>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-combobox v-model="classification" label="Classification*" required
                                        :items="classifications" hide-details
                                    ></v-combobox>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-combobox v-model="make" label="Make/Brand*" required
                                        :items="brands" hide-details
                                    ></v-combobox>
                                </v-flex>
                            
                                <v-flex xs12 sm12 md12>
                                    <v-combobox v-model="model" label="Model*" required
                                        :items="models" hide-details
                                    ></v-combobox>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-menu ref="yearModelMenu" :close-on-content-click="false" v-model="yearModelMenu" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                                        <v-text-field slot="activator" v-model="yearModel" label="Year Model" readonly hide-details placeholder="Optional"></v-text-field>
                                        <v-date-picker ref="picker" :max="new Date().toISOString().substr(0, 10)" v-model="yearModel" @input="save" reactive no-title></v-date-picker>
                                    </v-menu>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Plate Number" v-model="plateNumber" hide-details placeholder="Optional"
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs12 sm12 md12>
                                    <v-text-field label="Current Mileage in KM" v-model="odometer" hide-details placeholder="Optional"
                                    ></v-text-field>
                                </v-flex>

                                <v-layout justify-center v-if="showMotorcycleOnly">
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn dark color="blue darken-4" @click="saveMotorcycleDetails()">Save</v-btn>
                                    </v-card-actions>
                                </v-layout>
                            </v-flex>
                        </v-layout>

                        <v-layout justify-center>
                            <v-card-actions>
                                <v-btn dark color="red accent-4" @click="cancel()">Cancel</v-btn>
                                <v-btn dark color="blue darken-4" @click="saveUserDetails()">Save</v-btn>
                            </v-card-actions>
                        </v-layout>
                    </v-container>
                    
                </v-card-text>
            </v-card>

            <v-dialog v-model="progressDialog" persistent width="300">
                <v-card color="blue-grey darken-4">
                    <v-card-text class="subheading white--text"> Updating Profile
                        <v-layout row justify-center>
                        <v-progress-linear :indeterminate="true" :size="70" :width="5" color="white"
                        ></v-progress-linear>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="showAlert" bottom right :color="alertColor">{{alertMessage}}
                <v-btn dark small flat @click="showAlert = false">Close</v-btn>
            </v-snackbar>

		</v-app>
	</div>
</template>

<script>
import firebase from "firebase"
import "../../node_modules/firebaseui/dist/firebaseui.css"
import { mapGetters, mapActions, mapState } from "vuex"
import { db } from '../main.js'
import _ from 'lodash'

export default {
	data: () => ({
        drawer : null,
        profileDialog: false,
        email: "",
        emailRules: [v => !!v || 'Email is required', v => /.+@.+/.test(v) || 'Email must be valid'],
        dealers: [],
        brands: [],
        mobileNumber: "",
        mobileChecker: [v => v.length == 10|| 'Mobile number must be valid'],
        address: {
            brgy : "",
            city : "",
            state : ""
        },
        tin: "",
        fullName: "",
        firstName: "",
        middleName: "",
        lastName: "",
        dealer: "",
        make: "",
        model: "",
        models: [],
        yearModel: null,
        yearModelMenu: false,
        dateOfPurchase: null,
        dateOfPurchaseMenu: false,
        registrationDate: null,
        registrationDateMenu: false,
        transactions: [],
        engineNumber: "",
        chassisNumber: "",
        odometer: "",
        plateNumber: "",
        countryCode: "+63",
        progressDialog: false,
        showAlert: false,
        alertColor: "",
        alertMessage: "",
        motorcycles: [],
        customers: [],
        selectedMotorcycle: {},
        motorcycleHistoryDialog: false,
        serviceHistory: [],
        classification: "",
        classifications: ['CUB', 'Automatic','Business','Hi-End'],
        mcColor: "",
        showMotorcycleOnly: false,
        tempFullName: "",
        tempMobile: "",
        materialMaster: []
    }),
 
    methods : {
        async fetchNsMc() {
            let self = this
            self.materialMaster = []
            await db.collection("Motorcycles").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.materialMaster.push(doc.data())
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        async fetchNetsuiteMaterialMaster() {
            let self = this
            self.materialMaster = []
            // self.progressDialog = true
            self.$axios.defaults.headers.common['Authorization']=`NSJ ${self.$consumerKey}&${self.$consumerSecret}`
            self.$axios.defaults.headers.common['ns-token']= self.$tokenId
            self.$axios.defaults.headers.common['ns-token-secret']= self.$tokenSecret
            self.$axios.defaults.headers.common['Content-Type']= self.$contentType
            
            await self.$axios.get(self.$materialMaster).then(function(res){
                res.data.data.forEach(function(result) {
                    let code = {
                        // 'SOLO': 'CUB',
                        // 'SCOOTER': 'Automatic',
                        'BUSINESS': 'Business',
                        // 'BIG BIKE': 'Hi-End',
                        'SOLO/CUB/MOPED': 'CUB',
                        'SCOOTER/AUTOMATIC': 'Automatic',
                        'SPORTS/STREET': 'Hi-End'
                    }

                    for (let key in code) {
                        let re = new RegExp(key, 'gi')
                        result.values["custitem_item_industryclassification"][0]["text"] = result.values["custitem_item_industryclassification"][0]["text"].replace(re, code[key])
                    }

                    result.values.manufacturer = result.values.manufacturer.toLowerCase()
                    self.materialMaster.push({
                        classification: result.values["custitem_item_industryclassification"][0]["text"],
                        brand: result.values.manufacturer.charAt(0).toUpperCase() + result.values.manufacturer.slice(1),
                        model: result.values["custitem_item_description"][0]["text"]
                    })
                })
            }).then(function() {
                self.materialMaster = _.uniqBy(self.materialMaster, 'model');
                console.log(self.materialMaster)
                // self.progressDialog = false
            }).catch(function(error) {
                // self.progressDialog = false
                console.error("Error getting document: ", error)
            })
        },
        
        save(date) {
            this.$refs.yearModelMenu.save(date)
            this.$refs.picker.activePicker = "YEAR"
            this.yearModelMenu = false
        },

        async fetchMcDetails() {
            let self = this
            self.motorcycles = []
            if(self.user){
                db.collection("McDetails"+self.$stage)
                    .onSnapshot(function(querySnapshot) {
                        self.motorcycles = []
                        querySnapshot.forEach(function(doc){
                            if(self.user.email==doc.data().email && doc.data().status=="1") {
                                self.motorcycles.push(doc.data())
                            }
                        })
                    })
            } 
        },

        refresh(){
            let self = this
            self.forChangeMotorcycle = {}
            self.mcColor = ""
            self.dealer = ""
            self.make = ""
            self.model = ""
            self.yearModel = ""
            self.engineNumber = ""
            self.chassisNumber = ""
            self.odometer = ""
            self.plateNumber = ""
            self.dateOfPurchase = ""
            self.registrationDate = ""
            self.progressDialog = false
        },

        showLoading(){
            let self = this
            self.progressDialog = true
        },

        cancel() {
            let self = this
            self.$store.dispatch("setProfile", "0")
        },

        saveMotorcycleDetails(){
            let self = this
            if (self.dealer === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Dealer should not be blank"
                self.showAlert = true
            } else if (self.make === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Make/Brand should not be blank"
                self.showAlert = true
            } else if (self.model === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Model should not be blank"
                self.showAlert = true
            } else if (self.classification === "") {
                self.alertColor = "red accent-4"
                self.alertMessage = "Classification should not be blank"
                self.showAlert = true
            } else {
                self.showLoading()
                let timeStampId = new Date().getTime().toString()
                
                if (self.user.mobileNumber) {
                    self.tempMobile = self.user.mobileNumber
                } else {
                    self.tempMobile = self.mobileNumber
                }
                if (self.user.fullName) {
                    self.tempFullName = self.user.fullName
                } else {
                    self.tempFullName = `${self.firstName} ${self.lastName}`
                }
                let mcPayload = {
                    "owner": self.tempFullName,
                    "email": self.user.email,
                    "mobile": self.tempMobile,
                    "dealer": self.dealer,
                    "make": self.make,
                    "classification": self.classification,
                    "color": self.mcColor,
                    "model": self.model,
                    "yearModel": self.yearModel,
                    "engineNumber": self.engineNumber,
                    "chassisNumber": self.chassisNumber,
                    "plateNumber": self.plateNumber,
                    "odometer": self.odometer,
                    "dateOfPurchase": self.dateOfPurchase,
                    "registrationDate": self.registrationDate,
                    "transactions": self.transactions,
                    "status": "1",
                    "id": timeStampId
                }
                db.collection("McDetails"+self.$stage).doc(timeStampId).set(mcPayload).then(function(res) {
                    if (self.Scheduler.appointment) {
                        let payload = {
                            "motorcycleDetails": mcPayload,
                            "appointmentDate": self.Scheduler.appointment.appointmentDate,
                            "appointmentTime": self.Scheduler.appointment.appointmentTime,
                            "branch": self.Scheduler.appointment.branch,
                            "branchCode": self.Scheduler.appointment.branchCode,
                            "branchId": self.Scheduler.appointment.branchId,
                            "initialService": self.Scheduler.appointment.initialService,
                            "otherService": self.Scheduler.appointment.otherService,
                            "status": "ForApproval",
                            "estimateTime": self.Scheduler.appointment.estimateTime,
                            "formatedDate": self.Scheduler.appointment.formatedDate,
                            "timeHold": self.Scheduler.appointment.timeHold,
                            "customerType": "Self-Service",
                            "lastOdo": "0",
                            "odometer": self.Scheduler.appointment.odometer,
                            "mechanic": self.Scheduler.appointment.mechanic,
                            "status": "active"
                        }
                        
                        self.$store.dispatch("setAppointment", payload)
                    }
                    self.fetchMcDetails()
                    self.$store.dispatch("setProfile", "0")
                    self.refresh()
                }).catch(error => console.log(error))
            }
        },

        saveUserDetails() {
            let self = this
            firebase.auth().onAuthStateChanged(function(user) {
                if (self.dealer === "") {
                    self.alertColor = "red accent-4"
                    self.alertMessage = "Dealer should not be blank"
                    self.showAlert = true
                } else if (self.make === "") {
                    self.alertColor = "red accent-4"
                    self.alertMessage = "Make/Brand should not be blank"
                    self.showAlert = true
                } else if (self.model === "") {
                    self.alertColor = "red accent-4"
                    self.alertMessage = "Model should not be blank"
                    self.showAlert = true
                } else if (self.classification === "") {
                    self.alertColor = "red accent-4"
                    self.alertMessage = "Classification should not be blank"
                    self.showAlert = true
                } else if(self.mobileNumber.length !== 10) {          
                    self.alertMessage = "Please input valid mobile number"
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else if(self.firstName === "" || self.lastName === "") {
                    self.alertMessage = "First name and last name should not be blank. "
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else if (self.address.brgy === "" ||self.address.city === "" || self.address.state === "") {
                    self.alertMessage = "Please enter your address. "
                    self.alertColor = "red accent-4"
                    self.showAlert =true
                } else {
                    self.showLoading()
                    db.collection("Users"+self.$stage).doc(user.uid).update({
                        fullName: `${self.firstName} ${self.lastName}`,
                        firstName: self.firstName,
                        middleName: self.middleName,
                        lastName: self.lastName,
                        tin: self.tin,
                        countryCode: self.countryCode,
                        mobileNumber: self.mobileNumber,
                        email: self.email,
                        address: self.address,
                    }).then(function(doc) {
                        firebase.auth().onAuthStateChanged(function(user) {
                            if (user) {
                                let googleUser = {
                                    uid: user.uid,
                                    email: user.email,
                                    displayName: user.displayName,
                                    photoURL: user.photoURL,
                                }
                                self.$store.dispatch("setUser", googleUser).then(() => {
                                    user.getIdToken().then(function(accessToken) {
                                        self.$store.dispatch("setToken", accessToken).then(() => {
                                            self.$store.dispatch("setAuth", true).then(() => {
                                                db.collection("Users"+self.$stage).doc(user.uid)
                                                .onSnapshot(function(doc) {
                                                    self.$store.dispatch("setRole", doc.data().role).then(() => {}).catch(error => console.log(error))
                                                })
                                            }).catch(error => console.log(error))
                                        })
                                    })
                                })
                            } 
                        }, function(error) { console.log(error) })
                        //self.refresh()
                        self.saveMotorcycleDetails()
                    })
                }
            })
        },

        fetchBrands() {
            let self = this
            self.brands = []
            
            db.collection("Settings"+self.$stage).doc("Brands")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.brands.push(doc.data().brand)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        fetchDealers() {
            let self = this
            self.dealers = []
            
            db.collection("Settings"+self.$stage).doc("Dealers")
            .collection("Items").get().then(function(querySnapshot){
                querySnapshot.forEach(function(doc) {
                    self.dealers.push(doc.data().dealer)
                })
            }).catch(function(error) {
                console.log(error)
            })
        },

        // fetchClassification() {
        //     let self = this
        //     self.classifications = []
            
        //     db.collection("Settings"+self.$stage).doc("Classification")
        //     .collection("Items").get().then(function(querySnapshot){
        //         querySnapshot.forEach(function(doc) {
        //             self.classifications.push(doc.data().classification)
        //         })
        //     }).catch(function(error) {
        //         console.log(error)
        //     })
        // },

        async getRole() {
            let self = this
            if (self.user) {
                await firebase.auth().onAuthStateChanged(function(user) {
                    db.collection("Users"+self.$stage).doc(user.uid).get().then(function (doc) {
                        self.role = doc.data().role
                        self.firstName = doc.data().firstName
                        self.middleName = doc.data().middleName
                        self.lastName = doc.data().lastName
                        self.tin = doc.data().tin
                        self.mobileNumber = doc.data().mobileNumber
                        self.address = doc.data().address
                        self.assign = doc.data().assign
                        self.email = doc.data().email
                    }).then(function(){
                        self.fetchMcDetails()
                    }).catch(error => console.log(error))
                })
            }
        },
    },

    mounted() {
        let self = this
        self.fetchDealers()
        self.getRole()
        self.fetchNsMc()
        // self.fetchNetsuiteMaterialMaster()
        // self.fetchBrands()
        // self.fetchDealers()
        // self.fetchClassification()
        if (self.Auth.user.mobileNumber) {
            self.showMotorcycleOnly = true
        }
        if (self.Scheduler.appointment) {
            self.make = self.Scheduler.appointment.motorcycleDetails.make
            self.model = self.Scheduler.appointment.motorcycleDetails.model
            self.classification = self.Scheduler.appointment.motorcycleDetails.classification
            self.odometer = self.Scheduler.appointment.motorcycleDetails.odometer
            // "classification": self.classification,
            // "color": self.mcColor,
            // "model": self.model,
            // "yearModel": self.yearModel,
            // "engineNumber": self.engineNumber,
            // "chassisNumber": self.chassisNumber,
            // "plateNumber": self.plateNumber,
            // "odometer": self.odometer,
            // "dateOfPurchase": self.dateOfPurchase,
            // "registrationDate": self.registrationDate,
            // "transactions": self.transactions,
            // "status": "1",
            // "id": timeStampId
        }
    },

    watch: {
        yearModelMenu (val) {
            val && this.$nextTick(() => (this.$refs.picker.activePicker = "YEAR"))
        },

        yearModel (val) {
            let self = this
            if (val !== ""){
                self.yearModel = val.split('-')[0].trim()
            }
        },

        classification(val) {
            let self = this
            self.brands = []
            self.models = []
            self.make = ""
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.classification === val) {
                    self.brands.push(res.brand)
                }
            })
        },
        make(val) {
            let self = this
            self.models = []
            self.model = ""
            self.materialMaster.forEach(function(res) {
                if (res.brand === val && res.classification === self.classification) {
                    self.models.push(res.model)
                }
            })
        },

    },

    computed : {
        ...mapGetters(["user","appointment"]),
        ...mapState(["Auth","Scheduler"]),
    }
}

</script>

<style scoped>

</style>